module.exports = __webpack_public_path__ + "img/mars.aba2780e.png";